module.exports = __webpack_public_path__ + "img/bg-mision-2-7.30260e49.jpg";